function BreadCrumb({ title }) {
  return (
    <div className="breadCrumb">
      <hr />
      <h3 className="breadCrumb-text">{title}</h3>
      <hr />
    </div>
  );
}

export default BreadCrumb;
